import Fuse from "fuse.js";
import { mostUsedDomains } from "./utils";

const fuse = new Fuse(mostUsedDomains, {
  shouldSort: true,
  threshold: 0.3,
  location: 0,
  distance: 10,
  maxPatternLength: 32,
  minMatchCharLength: 2,
});

const emailCorrectorField = (emailField) => {
  const emailInput = emailField.querySelector("input");
  const messageCopy = emailField.getAttribute("data-email-corrector-copy");
  let messageDiv;

  emailInput.addEventListener("input", destroyMessage, false);
  emailInput.addEventListener("blur", checkValue, false);

  function destroyMessage() {
    if (messageDiv) {
      messageDiv.remove();
    }
  }

  function fillValue(value) {
    emailInput.value = `${emailInput.value.split("@")[0]}@${value}`;
    destroyMessage();
  }

  function showMessage(value) {
    // Check if domain is in list
    if (mostUsedDomains.includes(value)) {
      return false;
    }

    const domainSuggested = getSuggestion(value);

    if (domainSuggested) {
      messageDiv = document.createElement("div");
      messageDiv.classList.add(
        "form-text",
        "js-email-corrector-message",
        "o-email-corrector__message"
      );
      messageDiv.insertAdjacentHTML("beforeend", messageCopy.replace("[DOMAIN]", domainSuggested));
      messageDiv.dataset.domain = domainSuggested;
      emailInput.after(messageDiv);

      messageDiv.addEventListener("click", () => {
        fillValue(domainSuggested);
      });
    }

    return false;
  }

  function checkValue(event) {
    destroyMessage();
    const { value } = event.target;

    // This is ugly
    if (value.indexOf("@") !== -1 && value.split("@")[0] !== "") {
      showMessage(value.split("@")[1]);
    }
  }

  function getSuggestion(value) {
    const filteredDomains = fuse.search(value);
    if (filteredDomains.length !== 0) {
      return filteredDomains[0].item;
    }

    return false;
  }
};

export const emailCorrectorFieldsInit = () => {
  const emailFields = document.querySelectorAll(".js-email-corrector");

  Array.from(emailFields).forEach((emailField) => {
    emailCorrectorField(emailField);
  });
};

Domestika.emailCorrectorFieldsInit = emailCorrectorFieldsInit;

// Pre-init
Domestika.emailCorrectorFieldsInit();
